import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Civil } from './civil';
import { Address } from './address';
import { Family } from './family';
import { FamilyEnvironment } from './familyEnv';
import { SituationPro } from './situationPro';
import { Activity } from './activity';
import { OtherActivity } from './otherActivity';
import { Retraite } from './retraite';
import { Handicap } from './handicap';
import * as loadings from '../../../../constants/loadings/facilita/deathDeclaration';
import { updateDeathDeclaration, getUserServiceData } from './../../../../actions/facilita-api';
import { ProfessionOptions, FrenchTypes } from '../../../../constants/utils/connectionTypes';

export const Step2 = ({ userId, deathDeclaration, isLoading, serviceDatas }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const formRef = useRef();
    useEffect(() => {
        dispatch(getUserServiceData(userId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <article className="view-calc pt-3 mb-auto">
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-5">
                    <h1 className="text-primary font-weight-bolder mt-2 mb-3">Valider les informations du défunt au jour du décès</h1>
                    {/* <p className="h2 o-50 font-weight-bol ls-n1 mt-n1">Veuillez vérifier les informations relatives au défunt</p> */}
                </header>
            </div>
            <div className="auto-view scroll-auto py-4 pb-lg-0">
                <div className="container-fluid">
                    <form noValidate ref={formRef}>
                        <Civil deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
                        <Address deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
                        <Family deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
                        {
                            deathDeclaration.hasChildren ?
                                <FamilyEnvironment deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
                                :
                                ''
                        }

                        <SituationPro deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
                        {
                            deathDeclaration.professionalSituation.includes(ProfessionOptions.active) ?
                                <Activity activities={serviceDatas.filter(s => s.serviceType === FrenchTypes.activity)} isLoading={isLoading} userId={userId} deathDeclaration={deathDeclaration} />
                                :
                                ''
                        }

                        {
                            deathDeclaration.professionalSituation.includes(ProfessionOptions.retired) ?
                                <>
                                    {/* <hr className="my-0"/> */}
                                    <Retraite pensions={serviceDatas.filter(s => s.serviceType === FrenchTypes.pension)} isLoading={isLoading} userId={userId} deathDeclaration={deathDeclaration} />
                                </>
                                :
                                ''
                        }

                        {
                            deathDeclaration.professionalSituation.includes(ProfessionOptions.other) ?
                                <>
                                    {/* <hr className="my-0"/> */}
                                    <OtherActivity activities={serviceDatas.filter(s => s.serviceType === FrenchTypes.otherActivity)} isLoading={isLoading} userId={userId} deathDeclaration={deathDeclaration} />
                                </>
                                :
                                ''
                        }

                        {/* <Handicap deathDeclaration={deathDeclaration} /> */}
                    </form>
                </div>

                <div className="container-fluid mt-3">
                    <footer className="d-block mt-auto mb-sm text-right w-100">
                        <Link to={`/facilita/${userId}/declarer/step2`} className="btn btn-faded px-md-gutter mr-3">Retour</Link>
                        {
                            isLoading.includes(loadings.UPDATING_DECLARATION) ?
                                <button type="button" className="btn btn-info loading-btn px-md-gutter px-4 show">Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                                :
                                <button type="button" className="btn btn-info loading-btn px-md-gutter px-4" onClick={async (event) => {
                                    event.preventDefault();
                                    if (formRef.current.checkValidity()) {
                                        dispatch(updateDeathDeclaration(userId, { ...deathDeclaration, onBoardingStep: 4 }))
                                            .then(() => history.push(`/facilita/${userId}/declarer/step3`));
                                    }
                                    formRef.current.classList.add('was-validated');
                                }}>Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                        }
                    </footer>
                </div>
            </div>
        </article>
    );
};